// package: order
// file: order/model.proto

import * as address_model from "../address/model";
import * as common_enum_value_options from "../common/enum_value_options";
import * as common_source_type from "../common/source_type";
import * as common_shop_type from "../common/shop_type";
import * as common_activity_type from "../common/activity_type";
import * as item_base_model from "../item/base/model";
import * as order_base_model from "../order/base/model";
import * as pay_model from "../pay/model";
import * as linking_base_model from "../linking/base/model";

export const QianzhuFilmTicketAttrs = {
    encode(object) {
        const message = {};
        if (object.filmName != null) {
            if (object.filmName !== "") {
                message.filmName = String(object.filmName);
            }
        }
        if (object.showTime != null) {
            if (object.showTime !== "") {
                message.showTime = String(object.showTime);
            }
        }
        if (object.cinemaName != null) {
            if (object.cinemaName !== "") {
                message.cinemaName = String(object.cinemaName);
            }
        }
        if (object.hallName != null) {
            if (object.hallName !== "") {
                message.hallName = String(object.hallName);
            }
        }
        if (object.seatsDesc != null) {
            if (object.seatsDesc !== "") {
                message.seatsDesc = String(object.seatsDesc);
            }
        }
        if (object.filmType != null) {
            if (object.filmType !== "") {
                message.filmType = String(object.filmType);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            filmName: "",
            showTime: "",
            cinemaName: "",
            hallName: "",
            seatsDesc: "",
            filmType: "",
        };

        if (message.filmName != null) {
            object.filmName = message.filmName;
        }
        if (message.showTime != null) {
            object.showTime = message.showTime;
        }
        if (message.cinemaName != null) {
            object.cinemaName = message.cinemaName;
        }
        if (message.hallName != null) {
            object.hallName = message.hallName;
        }
        if (message.seatsDesc != null) {
            object.seatsDesc = message.seatsDesc;
        }
        if (message.filmType != null) {
            object.filmType = message.filmType;
        }
        return object;
    },
};

export const MagicItemUseRecord = {
    encode(object) {
        const message = {};
        if (object.magicItemAmount != null) {
            if (object.magicItemAmount !== 0) {
                message.magicItemAmount = String(object.magicItemAmount);
            }
        }
        if (object.marketPrice != null) {
            if (object.marketPrice !== 0) {
                message.marketPrice = String(object.marketPrice);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            magicItemAmount: 0,
            marketPrice: 0,
        };

        if (message.magicItemAmount != null) {
            object.magicItemAmount = parseInt(message.magicItemAmount, 10);
        }
        if (message.marketPrice != null) {
            object.marketPrice = parseInt(message.marketPrice, 10);
        }
        return object;
    },
};

export const RefundDetail = {
    encode(object) {
        const message = {};
        if (object.refundAmount != null) {
            if (object.refundAmount !== 0) {
                message.refundAmount = String(object.refundAmount);
            }
        }
        if (object.lifeRightsCashCost != null) {
            if (object.lifeRightsCashCost !== 0) {
                message.lifeRightsCashCost = String(object.lifeRightsCashCost);
            }
        }
        if (object.magicItemUseRecords != null) {
            if (!Array.isArray(object.magicItemUseRecords)) {
                throw TypeError("magicItemUseRecords: array expected");
            }
            if (object.magicItemUseRecords.length > 0) {
                message.magicItemUseRecords = [];
                for (let i = 0; i < object.magicItemUseRecords.length; ++i) {
                    message.magicItemUseRecords[i] = MagicItemUseRecord.encode(object.magicItemUseRecords[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            refundAmount: 0,
            lifeRightsCashCost: 0,
            magicItemUseRecords: [],
        };

        if (message.refundAmount != null) {
            object.refundAmount = parseInt(message.refundAmount, 10);
        }
        if (message.lifeRightsCashCost != null) {
            object.lifeRightsCashCost = parseInt(message.lifeRightsCashCost, 10);
        }
        if (message.magicItemUseRecords != null) {
            object.magicItemUseRecords = [];
            for (let i = 0; i < message.magicItemUseRecords.length; ++i) {
                object.magicItemUseRecords[i] = MagicItemUseRecord.decode(message.magicItemUseRecords[i]);
            }
        }
        return object;
    },
};

export const OrderExtra = {
    encode(object) {
        const message = {};
        if (object.taobaoDepositPrice != null) {
            if (object.taobaoDepositPrice !== 0) {
                message.taobaoDepositPrice = object.taobaoDepositPrice | 0;
            }
        }
        if (object.taobaoDepositCreatedTime != null) {
            if (object.taobaoDepositCreatedTime !== 0) {
                message.taobaoDepositCreatedTime = object.taobaoDepositCreatedTime | 0;
            }
        }
        if (object.taobaoDepositTaokeCreatedTime != null) {
            if (object.taobaoDepositTaokeCreatedTime !== 0) {
                message.taobaoDepositTaokeCreatedTime = object.taobaoDepositTaokeCreatedTime | 0;
            }
        }
        if (object.enqueueTime != null) {
            if (object.enqueueTime !== 0) {
                message.enqueueTime = object.enqueueTime | 0;
            }
        }
        if (object.activityType != null) {
            if (object.activityType !== 0) {
                message.activityType = object.activityType;
            }
        }
        if (object.expressPrice != null) {
            if (object.expressPrice !== 0) {
                message.expressPrice = String(object.expressPrice);
            }
        }
        if (object.itemSpecDesc != null) {
            if (object.itemSpecDesc !== "") {
                message.itemSpecDesc = String(object.itemSpecDesc);
            }
        }
        if (object.address != null) {
            message.address = address_model.Address.encode(object.address);
        }
        if (object.shippedTime != null) {
            if (object.shippedTime !== 0) {
                message.shippedTime = String(object.shippedTime);
            }
        }
        if (object.paymentMethod != null) {
            if (object.paymentMethod !== 0) {
                message.paymentMethod = object.paymentMethod;
            }
        }
        if (object.refundTime != null) {
            if (object.refundTime !== 0) {
                message.refundTime = String(object.refundTime);
            }
        }
        if (object.tags != null) {
            if (!Array.isArray(object.tags)) {
                throw TypeError("tags: array expected");
            }
            if (object.tags.length > 0) {
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i) {
                    message.tags[i] = object.tags[i];
                }
            }
        }
        if (object.buyAccount != null) {
            if (object.buyAccount !== "") {
                message.buyAccount = String(object.buyAccount);
            }
        }
        if (object.magicItemTitle != null) {
            if (object.magicItemTitle !== "") {
                message.magicItemTitle = String(object.magicItemTitle);
            }
        }
        if (object.refundFee != null) {
            if (object.refundFee !== 0) {
                message.refundFee = String(object.refundFee);
            }
        }
        if (object.orderLink != null) {
            if (object.orderLink !== "") {
                message.orderLink = String(object.orderLink);
            }
        }
        if (object.buySource != null) {
            if (object.buySource !== 0) {
                message.buySource = object.buySource;
            }
        }
        if (object.miniprogramCardID != null) {
            if (object.miniprogramCardID !== "") {
                message.miniprogramCardID = String(object.miniprogramCardID);
            }
        }
        if (object.wechatGroupNumber != null) {
            if (object.wechatGroupNumber !== "") {
                message.wechatGroupNumber = String(object.wechatGroupNumber);
            }
        }
        if (object.activityName != null) {
            if (object.activityName !== "") {
                message.activityName = String(object.activityName);
            }
        }
        if (object.trainStartDate != null) {
            if (object.trainStartDate !== "") {
                message.trainStartDate = String(object.trainStartDate);
            }
        }
        if (object.technicalServiceFee != null) {
            if (object.technicalServiceFee !== 0) {
                message.technicalServiceFee = String(object.technicalServiceFee);
            }
        }
        if (object.sceneID != null) {
            if (object.sceneID !== "") {
                message.sceneID = String(object.sceneID);
            }
        }
        if (object.qianzhuFilmTicketAttrs != null) {
            message.qianzhuFilmTicketAttrs = QianzhuFilmTicketAttrs.encode(object.qianzhuFilmTicketAttrs);
        }
        if (object.groupID != null) {
            if (object.groupID !== "") {
                message.groupID = String(object.groupID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            taobaoDepositPrice: 0,
            taobaoDepositCreatedTime: 0,
            taobaoDepositTaokeCreatedTime: 0,
            enqueueTime: 0,
            activityType: 0,
            expressPrice: 0,
            itemSpecDesc: "",
            address: null,
            shippedTime: 0,
            paymentMethod: 0,
            refundTime: 0,
            tags: [],
            buyAccount: "",
            magicItemTitle: "",
            refundFee: 0,
            orderLink: "",
            buySource: 0,
            miniprogramCardID: "",
            wechatGroupNumber: "",
            activityName: "",
            trainStartDate: "",
            technicalServiceFee: 0,
            sceneID: "",
            qianzhuFilmTicketAttrs: null,
            groupID: "",
        };

        if (message.taobaoDepositPrice != null) {
            object.taobaoDepositPrice = message.taobaoDepositPrice;
        }
        if (message.taobaoDepositCreatedTime != null) {
            object.taobaoDepositCreatedTime = message.taobaoDepositCreatedTime;
        }
        if (message.taobaoDepositTaokeCreatedTime != null) {
            object.taobaoDepositTaokeCreatedTime = message.taobaoDepositTaokeCreatedTime;
        }
        if (message.enqueueTime != null) {
            object.enqueueTime = message.enqueueTime;
        }
        if (message.activityType != null) {
            object.activityType = message.activityType;
        }
        if (message.expressPrice != null) {
            object.expressPrice = parseInt(message.expressPrice, 10);
        }
        if (message.itemSpecDesc != null) {
            object.itemSpecDesc = message.itemSpecDesc;
        }
        if (message.address != null) {
            object.address = address_model.Address.decode(message.address);
        }
        if (message.shippedTime != null) {
            object.shippedTime = parseInt(message.shippedTime, 10);
        }
        if (message.paymentMethod != null) {
            object.paymentMethod = message.paymentMethod;
        }
        if (message.refundTime != null) {
            object.refundTime = parseInt(message.refundTime, 10);
        }
        if (message.tags != null) {
            object.tags = [];
            for (let i = 0; i < message.tags.length; ++i) {
                    object.tags[i] = message.tags[i];
            }
        }
        if (message.buyAccount != null) {
            object.buyAccount = message.buyAccount;
        }
        if (message.magicItemTitle != null) {
            object.magicItemTitle = message.magicItemTitle;
        }
        if (message.refundFee != null) {
            object.refundFee = parseInt(message.refundFee, 10);
        }
        if (message.orderLink != null) {
            object.orderLink = message.orderLink;
        }
        if (message.buySource != null) {
            object.buySource = message.buySource;
        }
        if (message.miniprogramCardID != null) {
            object.miniprogramCardID = message.miniprogramCardID;
        }
        if (message.wechatGroupNumber != null) {
            object.wechatGroupNumber = message.wechatGroupNumber;
        }
        if (message.activityName != null) {
            object.activityName = message.activityName;
        }
        if (message.trainStartDate != null) {
            object.trainStartDate = message.trainStartDate;
        }
        if (message.technicalServiceFee != null) {
            object.technicalServiceFee = parseInt(message.technicalServiceFee, 10);
        }
        if (message.sceneID != null) {
            object.sceneID = message.sceneID;
        }
        if (message.qianzhuFilmTicketAttrs != null) {
            object.qianzhuFilmTicketAttrs = QianzhuFilmTicketAttrs.decode(message.qianzhuFilmTicketAttrs);
        }
        if (message.groupID != null) {
            object.groupID = message.groupID;
        }
        return object;
    },
};

export const OrderDetail = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.buyType != null) {
            if (object.buyType !== 0) {
                message.buyType = object.buyType;
            }
        }
        if (object.tradeID != null) {
            if (object.tradeID !== "") {
                message.tradeID = String(object.tradeID);
            }
        }
        if (object.tradeParentID != null) {
            if (object.tradeParentID !== "") {
                message.tradeParentID = String(object.tradeParentID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.itemID != null) {
            if (object.itemID !== "") {
                message.itemID = String(object.itemID);
            }
        }
        if (object.sourceIID != null) {
            if (object.sourceIID !== "") {
                message.sourceIID = String(object.sourceIID);
            }
        }
        if (object.itemTitle != null) {
            if (object.itemTitle !== "") {
                message.itemTitle = String(object.itemTitle);
            }
        }
        if (object.sourceType != null) {
            if (object.sourceType !== 0) {
                message.sourceType = object.sourceType;
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = object.createdTime | 0;
            }
        }
        if (object.commissionRate != null) {
            if (object.commissionRate !== "") {
                message.commissionRate = String(object.commissionRate);
            }
        }
        if (object.alipayTotalPrice != null) {
            if (object.alipayTotalPrice !== "") {
                message.alipayTotalPrice = String(object.alipayTotalPrice);
            }
        }
        if (object.price != null) {
            if (object.price !== 0) {
                message.price = object.price | 0;
            }
        }
        if (object.depositPrice != null) {
            if (object.depositPrice !== 0) {
                message.depositPrice = object.depositPrice | 0;
            }
        }
        if (object.shopType != null) {
            if (object.shopType !== 0) {
                message.shopType = object.shopType;
            }
        }
        if (object.shopName != null) {
            if (object.shopName !== "") {
                message.shopName = String(object.shopName);
            }
        }
        if (object.sellerShopTitle != null) {
            if (object.sellerShopTitle !== "") {
                message.sellerShopTitle = String(object.sellerShopTitle);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        if (object.presaleTailPayTime != null) {
            if (object.presaleTailPayTime !== 0) {
                message.presaleTailPayTime = object.presaleTailPayTime | 0;
            }
        }
        if (object.itemBase != null) {
            message.itemBase = item_base_model.ItemBase.encode(object.itemBase);
        }
        if (object.extra != null) {
            message.extra = OrderExtra.encode(object.extra);
        }
        if (object.commission != null) {
            if (object.commission !== 0) {
                message.commission = String(object.commission);
            }
        }
        if (object.isDelete != null) {
            if (object.isDelete !== false) {
                message.isDelete = Boolean(object.isDelete);
            }
        }
        if (object.shareUserID != null) {
            if (object.shareUserID !== "") {
                message.shareUserID = String(object.shareUserID);
            }
        }
        if (object.buyUserID != null) {
            if (object.buyUserID !== "") {
                message.buyUserID = String(object.buyUserID);
            }
        }
        if (object.pID != null) {
            if (object.pID !== "") {
                message.pID = String(object.pID);
            }
        }
        if (object.userCommissionRate != null) {
            if (object.userCommissionRate !== 0) {
                message.userCommissionRate = String(object.userCommissionRate);
            }
        }
        if (object.userCommissionNum != null) {
            if (object.userCommissionNum !== 0) {
                message.userCommissionNum = String(object.userCommissionNum);
            }
        }
        if (object.itemThumbnailURL != null) {
            if (object.itemThumbnailURL !== "") {
                message.itemThumbnailURL = String(object.itemThumbnailURL);
            }
        }
        if (object.itemNum != null) {
            if (object.itemNum !== 0) {
                message.itemNum = String(object.itemNum);
            }
        }
        if (object.payPrice != null) {
            if (object.payPrice !== 0) {
                message.payPrice = String(object.payPrice);
            }
        }
        if (object.sellerNick != null) {
            if (object.sellerNick !== "") {
                message.sellerNick = String(object.sellerNick);
            }
        }
        if (object.paidTime != null) {
            if (object.paidTime !== 0) {
                message.paidTime = String(object.paidTime);
            }
        }
        if (object.earnedTime != null) {
            if (object.earnedTime !== 0) {
                message.earnedTime = String(object.earnedTime);
            }
        }
        if (object.tkStatus != null) {
            if (object.tkStatus !== 0) {
                message.tkStatus = object.tkStatus;
            }
        }
        if (object.pubSharePreFee != null) {
            if (object.pubSharePreFee !== 0) {
                message.pubSharePreFee = String(object.pubSharePreFee);
            }
        }
        if (object.incomeRate != null) {
            if (object.incomeRate !== 0) {
                message.incomeRate = String(object.incomeRate);
            }
        }
        if (object.createdAt != null) {
            if (object.createdAt !== 0) {
                message.createdAt = String(object.createdAt);
            }
        }
        if (object.presaleTailEndTime != null) {
            if (object.presaleTailEndTime !== 0) {
                message.presaleTailEndTime = String(object.presaleTailEndTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            buyType: 0,
            tradeID: "",
            tradeParentID: "",
            userID: "",
            itemID: "",
            sourceIID: "",
            itemTitle: "",
            sourceType: 0,
            status: 0,
            createdTime: 0,
            commissionRate: "",
            alipayTotalPrice: "",
            price: 0,
            depositPrice: 0,
            shopType: 0,
            shopName: "",
            sellerShopTitle: "",
            imageURL: "",
            presaleTailPayTime: 0,
            itemBase: null,
            extra: null,
            commission: 0,
            isDelete: false,
            shareUserID: "",
            buyUserID: "",
            pID: "",
            userCommissionRate: 0,
            userCommissionNum: 0,
            itemThumbnailURL: "",
            itemNum: 0,
            payPrice: 0,
            sellerNick: "",
            paidTime: 0,
            earnedTime: 0,
            tkStatus: 0,
            pubSharePreFee: 0,
            incomeRate: 0,
            createdAt: 0,
            presaleTailEndTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.buyType != null) {
            object.buyType = message.buyType;
        }
        if (message.tradeID != null) {
            object.tradeID = message.tradeID;
        }
        if (message.tradeParentID != null) {
            object.tradeParentID = message.tradeParentID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.itemID != null) {
            object.itemID = message.itemID;
        }
        if (message.sourceIID != null) {
            object.sourceIID = message.sourceIID;
        }
        if (message.itemTitle != null) {
            object.itemTitle = message.itemTitle;
        }
        if (message.sourceType != null) {
            object.sourceType = message.sourceType;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.createdTime != null) {
            object.createdTime = message.createdTime;
        }
        if (message.commissionRate != null) {
            object.commissionRate = message.commissionRate;
        }
        if (message.alipayTotalPrice != null) {
            object.alipayTotalPrice = message.alipayTotalPrice;
        }
        if (message.price != null) {
            object.price = message.price;
        }
        if (message.depositPrice != null) {
            object.depositPrice = message.depositPrice;
        }
        if (message.shopType != null) {
            object.shopType = message.shopType;
        }
        if (message.shopName != null) {
            object.shopName = message.shopName;
        }
        if (message.sellerShopTitle != null) {
            object.sellerShopTitle = message.sellerShopTitle;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        if (message.presaleTailPayTime != null) {
            object.presaleTailPayTime = message.presaleTailPayTime;
        }
        if (message.itemBase != null) {
            object.itemBase = item_base_model.ItemBase.decode(message.itemBase);
        }
        if (message.extra != null) {
            object.extra = OrderExtra.decode(message.extra);
        }
        if (message.commission != null) {
            object.commission = parseInt(message.commission, 10);
        }
        if (message.isDelete != null) {
            object.isDelete = message.isDelete;
        }
        if (message.shareUserID != null) {
            object.shareUserID = message.shareUserID;
        }
        if (message.buyUserID != null) {
            object.buyUserID = message.buyUserID;
        }
        if (message.pID != null) {
            object.pID = message.pID;
        }
        if (message.userCommissionRate != null) {
            object.userCommissionRate = parseInt(message.userCommissionRate, 10);
        }
        if (message.userCommissionNum != null) {
            object.userCommissionNum = parseInt(message.userCommissionNum, 10);
        }
        if (message.itemThumbnailURL != null) {
            object.itemThumbnailURL = message.itemThumbnailURL;
        }
        if (message.itemNum != null) {
            object.itemNum = parseInt(message.itemNum, 10);
        }
        if (message.payPrice != null) {
            object.payPrice = parseInt(message.payPrice, 10);
        }
        if (message.sellerNick != null) {
            object.sellerNick = message.sellerNick;
        }
        if (message.paidTime != null) {
            object.paidTime = parseInt(message.paidTime, 10);
        }
        if (message.earnedTime != null) {
            object.earnedTime = parseInt(message.earnedTime, 10);
        }
        if (message.tkStatus != null) {
            object.tkStatus = message.tkStatus;
        }
        if (message.pubSharePreFee != null) {
            object.pubSharePreFee = parseInt(message.pubSharePreFee, 10);
        }
        if (message.incomeRate != null) {
            object.incomeRate = parseInt(message.incomeRate, 10);
        }
        if (message.createdAt != null) {
            object.createdAt = parseInt(message.createdAt, 10);
        }
        if (message.presaleTailEndTime != null) {
            object.presaleTailEndTime = parseInt(message.presaleTailEndTime, 10);
        }
        return object;
    },
};

export const SourceTypeDesc = {
    encode(object) {
        const message = {};
        if (object.sourceType != null) {
            if (object.sourceType !== 0) {
                message.sourceType = object.sourceType;
            }
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            sourceType: 0,
            desc: "",
        };

        if (message.sourceType != null) {
            object.sourceType = message.sourceType;
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        return object;
    },
};

export const RefundOrder = {
    encode(object) {
        const message = {};
        if (object.orderDetail != null) {
            message.orderDetail = OrderDetail.encode(object.orderDetail);
        }
        if (object.refundStartTime != null) {
            if (object.refundStartTime !== 0) {
                message.refundStartTime = String(object.refundStartTime);
            }
        }
        if (object.refundEndTime != null) {
            if (object.refundEndTime !== 0) {
                message.refundEndTime = String(object.refundEndTime);
            }
        }
        if (object.refundFee != null) {
            if (object.refundFee !== 0) {
                message.refundFee = String(object.refundFee);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            orderDetail: null,
            refundStartTime: 0,
            refundEndTime: 0,
            refundFee: 0,
            status: 0,
        };

        if (message.orderDetail != null) {
            object.orderDetail = OrderDetail.decode(message.orderDetail);
        }
        if (message.refundStartTime != null) {
            object.refundStartTime = parseInt(message.refundStartTime, 10);
        }
        if (message.refundEndTime != null) {
            object.refundEndTime = parseInt(message.refundEndTime, 10);
        }
        if (message.refundFee != null) {
            object.refundFee = parseInt(message.refundFee, 10);
        }
        if (message.status != null) {
            object.status = message.status;
        }
        return object;
    },
};


export const RefundFailedCause = {
    REFUND_FAILED_CAUSE_UNDEFINED: 0,
    REFUND_FAILED_CAUSE_USE_LOCK_SOURCE: 1,
    REFUND_FAILED_CAUSE_INVALID_ARGUMENT: 2,
    REFUND_FAILED_CAUSE_AMOUNT_INVALID: 3,
    REFUND_FAILED_CAUSE_TIMEOUT: 4,
};

export const RefundFailedCauseDisplayName = {
    0 /* REFUND_FAILED_CAUSE_UNDEFINED */: "未定义",
    1 /* REFUND_FAILED_CAUSE_USE_LOCK_SOURCE */: "系统检测到退费期间使用了话费券/0元补贴金，故退款失败",
    2 /* REFUND_FAILED_CAUSE_INVALID_ARGUMENT */: "参数错误",
    3 /* REFUND_FAILED_CAUSE_AMOUNT_INVALID */: "退款金额超限制",
    4 /* REFUND_FAILED_CAUSE_TIMEOUT */: "退款超时",
};

export const SearchByTradeParentIDAndSourceTypeCode = {
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_UNDEFINED: 0,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_EMPLOY: 1,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_ON_THE_WAY: 2,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_EMPTY: 3,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_MAX: 4,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_ALLOWANCE: 5,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_FAILED: 100,
    SEARCH_BY_TRADE_PARENT_ID_AND_SOURCE_TYPE_CODE_SUCCESS: 200,
};


export const RefundStatus = {
    REFUND_STATUS_UNDEFINED: 0,
    REFUND_STATUS_CREATED: 1,
    REFUND_STATUS_SUCCESS: 2,
    REFUND_STATUS_FAIL: 3,
};

export const RefundStatusDisplayName = {
    0 /* REFUND_STATUS_UNDEFINED */: "没有维权",
    1 /* REFUND_STATUS_CREATED */: "维权创建",
    2 /* REFUND_STATUS_SUCCESS */: "维权成功",
    3 /* REFUND_STATUS_FAIL */: "维权失败",
};

export const OrderTag = {
    ORDER_TAG_UNDEFINED: 0,
    ORDER_TAG_LIFE_RIGHTS: 1,
    ORDER_TAG_OFFICIAL_FACTORY: 2,
    ORDER_TAG_LOCKED_COMMISSION: 3,
    ORDER_TAG_RETRIEVED_BY_USER: 4,
    ORDER_TAG_LIFE_RIGHTS_SECKILL: 5,
    ORDER_TAG_LIFE_RIGHTS_GAME_POINT_EXCHANGE: 6,
    ORDER_TAG_PRICE_COMPARE: 7,
    ORDER_TAG_LIFE_RIGHTS_PHONE_BILL: 8,
    ORDER_TAG_PLATFORM_NEW_USER: 9,
    ORDER_TAG_TRAIN_TICKET: 10,
    ORDER_TAG_EVIL_BIND: 11,
    ORDER_TAG_JINGDONG_JINGXI_ORDER: 12,
    ORDER_TAG_USER_SELF_REFUND: 13,
    ORDER_TAG_CMS_REFUND: 14,
    ORDER_TAG_DELETE: 15,
    ORDER_TAG_GIVE_0YUAN_BUY_FUND: 16,
    ORDER_TAG_LIFE_RIGHTS_ELECTRICITY_BILL: 17,
    ORDER_TAG_OUTER_SITE_ITEM_EXCHANGE: 18,
    ORDER_TAG_GIVE_ALLOWANCE: 19,
    ORDER_TAG_OUTER_SITE_MYSTERY_BOX_PRIZE: 20,
};


export const BuyBackOrderStatus = {
    BUY_BACK_ORDER_STATUS_UNDEFINED: 0,
    BUY_BACK_ORDER_STATUS_ALL: 1,
    BUY_BACK_ORDER_STATUS_SUCCESS: 2,
    BUY_BACK_ORDER_STATUS_FAIL: 3,
};


